module.exports = __webpack_public_path__ + "img/CTXC.5f56d366.svg";